<div class="confirmation-dialog">
  <div class="dialog-title-bar">
    <h2 class="dialog-title" data-testid="specific-files-confirm-modal">
      Cancel files
    </h2>
    <button
      type="button"
      class="close-btn"
      aria-label="Close dialog"
      (click)="onClose()"
      data-testid="specific-files-confirm-close"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-body" data-testid="specific-files-confirm-modal">
    <p class="confirmation__summary">
      You have selected <strong>{{ getFilesCountWithLabel() }}</strong> for cancellation. No additional translation work will be completed for {{ totalSelectedFiles() === 1 ? 'this file' : 'these files' }} once you confirm. This action cannot be undone.
    </p>

    <p class="confirmation__question">
      Are you sure you want to cancel the translation of the following {{ totalSelectedFiles() === 1 ? 'file' : 'files' }}?
    </p>

    <div class="confirmation__groups">
      @for (group of languageGroups(); track group.targetLanguageCode) {
        <div
          class="confirmation__group"
          [attr.data-testid]="'specific-files-confirm-group-' + group.targetLanguageCode"
        >
          <h3 class="confirmation__group-title">
            {{ group.targetLanguageLabel }}
          </h3>
          <ol class="confirmation__file-list">
            @for (file of getSortedGroupFiles(group); track file.fileUid) {
              <li class="confirmation__file-item">
                {{ file.fileName }}
              </li>
            }
          </ol>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="btn btn-outline"
      (click)="onBack()"
      data-testid="specific-files-confirm-back"
    >
      Back
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onNext()"
      data-testid="specific-files-confirm-next"
    >
      Next
    </button>
  </mat-dialog-actions>
</div>
